/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'shopping_mall': {
    width: 99,
    height: 110,
    viewBox: '0 0 99 110',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M46.845 18.047C46.845 8.088 54.814 0 64.625 0c9.812 0 17.78 8.088 17.78 18.047V31.28h10.669L99 96.25H75.97L68.75 38.5H35.52l.658-7.219h10.668V18.047zm30.82 0c0-7.374-5.775-13.235-13.04-13.235-7.264 0-13.038 5.861-13.038 13.235V31.28h26.077V18.047z" _fill="#3D4B55"/><path pid="1" d="M34.5 14c-9.847 0-17.845 8.067-17.845 18v13.2H5.948L0 110h69l-5.948-64.8H52.345V32c0-9.933-7.998-18-17.845-18zm0 4.8c7.291 0 13.086 5.845 13.086 13.2v13.2H21.414V32c0-7.355 5.795-13.2 13.086-13.2z" _fill="#3D4B55"/>'
  }
})
